import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchCodeHList = async (params) => {
  const response = await get("/admin/comm/code/codeHList", { params });

  return response;
};

export function useCodeList() {
  const [searchParams, setSearchParams] = useSearchParams();


  const methods = useForm({
    defaultValues: {
      searchWrd: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });

  const searchWrd = searchParams.get("searchWrd") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = parseInt(searchParams.get("pageSize") || "10", 10);

  const queryParam = {
    searchWrd,
    pageIndex,
    recordCountPerPage,

  };

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["codeHList", queryParam],
    queryFn: () => fetchCodeHList(queryParam),
    // enabled: false, // 더미 데이터 사용중 false
    keepPreviousData: true,
    staleTime: 600000,
  });

  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const changePageSize = (size) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageSize", String(size));
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const initialCodeH = {
    code: "codeH",
    comhCode: "",
    comhName: "",
    hsort: 1,
    huseYn: "Y",
    hnotice: "",
    isNew: true,
    isEdited: false,
  }

  const initialCodeD = {
    code: "codeD",
    comhCode: "",
    comdCode: "",
    comdName: "",
    usrDfn1: "",
    usrDfn2: "",
    usrDfn3: "",
    dsort: 1,
    duseYn: "Y",
    dnotice: "",
    isNew: true,
    isEdited: false,
  }

  const useYnOptions = [
          { key: "Y", name: "사용" },
          { key: "N", name: "미사용" },
      ];


      

  return {
    methods,
    data,
    isLoading,
    isError,
    error,
    onSubmit,
    handlePageChange,
    changePageSize,
    pageIndex,
    recordCountPerPage,
    refetch,
    refreshList,
    initialCodeH,
    initialCodeD,
    useYnOptions,
  };
}
